const ajaxFilter = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const mapElement = document.getElementById("map");
        if (mapElement) {
            filterPosts("testimonial");
        }
    });
};

export default ajaxFilter;

const filterPosts = (value) => {
    const data = {
        action: "my_action",
        security: MyAjax.security,
        post_type: value,
    };
    // console.log(data)
    $.post(MyAjax.ajaxurl, data, (response) => {
        if (response.data === "empty") {
            console.log("Nessun risultato risponde alle tue richieste ( ajax ok )");
        } else {
            initMap(response.data);
            console.log("Ok Risultati recuperati ( ajax ok )", response.data.length);
        }
    });
}
